<dx-popup
  [visible]="displayDialog"
  [height]="'auto'"
  [width]="600"
  (onHiding)="closeDialog()"
  [showCloseButton]="false"
  [showTitle]="true"
>
  <div *dxTemplate="let _ of 'title'" class="export-header">
    <div>
      <i class="fas fa-search-dollar"></i>
      <strong class="ml-2">Exporter les données d'analyse financière</strong>
    </div>
    <div class="export-header-actions">
      <yo-button
        [theme]="ButtonThemeEnum.SAVE"
        iconClass="fa fa-check"
        tooltip="Exporter"
        (onClick)="export(selectedTab)">
      </yo-button>
      <yo-button
        [theme]="ButtonThemeEnum.CANCEL"
        iconClass="fas fa-times"
        tooltip="Fermer"
        (onClick)="closeDialog()">
      </yo-button>
    </div>
  </div>

  <dx-tab-panel
    [selectedIndex]="selectedTabIndex()"
    (onTitleClick)="tabChange($event)">
    <dxi-item title="Facturation par prestation">
      <div class="export-settings">
        <yo-tagbox
          [data]="uniteProductionList()"
          [selectedItems]="selectedUniteProductionList"
          (onValueChange)="updateValuePrestation($event, cellTypes.UNITE_PRODUCTION)"
          placeholder="Unité de production">
        </yo-tagbox>
        <yo-tagbox
          [data]="pointFacturationList"
          [selectedItems]="selectedPointFacturationList"
          (onValueChange)="updateValuePrestation($event, cellTypes.POINT_FACTURATION)"
          placeholder="Point de facturation">
        </yo-tagbox>
        <yo-tagbox
          [data]="pointLivraisonList"
          [selectedItems]="selectedPointLivraisonList"
          (onValueChange)="updateValuePrestation($event, cellTypes.POINT_LIVRAISON)"
          [disabled]="!isParentSelected(selectedPointFacturationList)"
          placeholder="Point de livraison">
        </yo-tagbox>
        <yo-tagbox
          [data]="offreAlimentaireList"
          [selectedItems]="selectedOffreAlimentaireList"
          (onValueChange)="updateValuePrestation($event, cellTypes.OFFRE_ALIMENTAIRE)"
          [disabled]="!isParentSelected(selectedPointLivraisonList)"
          placeholder="Offre alimentaire">
        </yo-tagbox>
        <yo-tagbox
          [data]="prestationList"
          [selectedItems]="selectedPrestationList"
          (onValueChange)="updateValuePrestation($event, cellTypes.PRESTATION)"
          [disabled]="!isParentSelected(selectedOffreAlimentaireList)"
          placeholder="Prestation">
        </yo-tagbox>
        <yo-tagbox
          [data]="repasList"
          [selectedItems]="selectedRepasList"
          (onValueChange)="updateValuePrestation($event, cellTypes.REPAS)"
          [disabled]="!isParentSelected(selectedPrestationList)"
          placeholder="Repas">
        </yo-tagbox>
        <yo-tagbox
          [data]="regimeList"
          [selectedItems]="selectedRegimeList"
          (onValueChange)="updateValuePrestation($event, cellTypes.REGIME)"
          [disabled]="!isParentSelected(selectedPrestationList)"
          placeholder="Régime">
        </yo-tagbox>
        <yo-date-range-box
          (onValueChange)="onDateFilterValueChange($event)"
          height="45px"
          [selectedDates]="selectedPeriode">
        </yo-date-range-box>
      </div>
    </dxi-item>

    <dxi-item title="Facturation par famille de produit">
      <div class="export-settings">
        <yo-tagbox
          [data]="uniteProductionList()"
          [selectedItems]="selectedUniteProductionList"
          (onValueChange)="updateValuePrestation($event, cellTypes.UNITE_PRODUCTION)"
          placeholder="Unité de production">
        </yo-tagbox>
        <yo-tagbox
          [data]="pointFacturationList"
          [selectedItems]="selectedPointFacturationList"
          (onValueChange)="updateValuePrestation($event, cellTypes.POINT_FACTURATION)"
          [disabled]="!isParentSelected(selectedUniteProductionList)"
          placeholder="Point de facturation">
        </yo-tagbox>
        <yo-tagbox
          [data]="pointLivraisonList"
          [selectedItems]="selectedPointLivraisonList"
          (onValueChange)="updateValuePrestation($event, cellTypes.POINT_LIVRAISON)"
          [disabled]="!isParentSelected(selectedPointFacturationList)"
          placeholder="Point de livraison">
        </yo-tagbox>
        <yo-tagbox
          [data]="offreAlimentaireList"
          [selectedItems]="selectedOffreAlimentaireList"
          (onValueChange)="updateValuePrestation($event, cellTypes.OFFRE_ALIMENTAIRE)"
          [disabled]="!isParentSelected(selectedPointLivraisonList)"
          placeholder="Offre alimentaire">
        </yo-tagbox>
        <yo-tagbox
          [data]="prestationList"
          [selectedItems]="selectedPrestationList"
          (onValueChange)="updateValuePrestation($event, cellTypes.PRESTATION)"
          [disabled]="!isParentSelected(selectedOffreAlimentaireList)"
          placeholder="Prestation">
        </yo-tagbox>
        <yo-tagbox
          [data]="repasList"
          [selectedItems]="selectedRepasList"
          (onValueChange)="updateValuePrestation($event, cellTypes.REPAS)"
          [disabled]="!isParentSelected(selectedPrestationList)"
          placeholder="Repas">
        </yo-tagbox>
        <yo-tagbox
          [data]="regimeList"
          [selectedItems]="selectedRegimeList"
          (onValueChange)="updateValuePrestation($event, cellTypes.REGIME)"
          [disabled]="!isParentSelected(selectedPrestationList)"
          placeholder="Régime">
        </yo-tagbox>
        <yo-date-range-box
          (onValueChange)="onDateFilterValueChange($event)"
          height="45px"
          [selectedDates]="selectedPeriode">
        </yo-date-range-box>
      </div>
    </dxi-item>

    <dxi-item title="Facturation par plat">
      <div class="export-settings">
        <yo-tagbox
          [data]="uniteProductionList()"
          [selectedItems]="selectedUniteProductionList"
          (onValueChange)="updateValuePlat($event, cellTypes.UNITE_PRODUCTION)"
          placeholder="Unité de production">
        </yo-tagbox>
        <yo-tagbox
          [data]="pointLivraisonList"
          [selectedItems]="selectedPointLivraisonList"
          (onValueChange)="updateValuePlat($event, cellTypes.POINT_LIVRAISON)"
          [disabled]="!isParentSelected(selectedUniteProductionList)"
          placeholder="Point de livraison">
        </yo-tagbox>
        <yo-tagbox
          [data]="offreAlimentaireList"
          [selectedItems]="selectedOffreAlimentaireList"
          (onValueChange)="updateValuePlat($event, cellTypes.OFFRE_ALIMENTAIRE)"
          [disabled]="!isParentSelected(selectedPointLivraisonList)"
          placeholder="Offre alimentaire">
        </yo-tagbox>
        <yo-tagbox
          [data]="prestationList"
          [selectedItems]="selectedPrestationList"
          (onValueChange)="updateValuePlat($event, cellTypes.PRESTATION)"
          [disabled]="!isParentSelected(selectedOffreAlimentaireList)"
          placeholder="Prestation">
        </yo-tagbox>
        <yo-tagbox
          [data]="repasList"
          [selectedItems]="selectedRepasList"
          (onValueChange)="updateValuePlat($event, cellTypes.REPAS)"
          [disabled]="!isParentSelected(selectedPrestationList)"
          placeholder="Repas">
        </yo-tagbox>
        <yo-tagbox
          [data]="regimeList"
          [selectedItems]="selectedRegimeList"
          (onValueChange)="updateValuePlat($event, cellTypes.REGIME)"
          [disabled]="!isParentSelected(selectedPrestationList)"
          placeholder="Régime">
        </yo-tagbox>
        <yo-date-range-box
          (onValueChange)="onDateFilterValueChange($event)"
          height="45px"
          [selectedDates]="selectedPeriode">
        </yo-date-range-box>
      </div>
    </dxi-item>
  </dx-tab-panel>
</dx-popup>
